export function* rootSagas() {
  yield console.log('Hi from saga');
}
